<template>
  <div class="pt-3" v-if="init.termsAndConditions">
    <!-- Header -->
    <list-header title="Terms & Conditions" />

    <!-- Terms & Conditions -->
    <div class="scss-content scss-text-white-space-preserved text-start">
      {{ init.termsAndConditions }}
    </div>
  </div>
</template>

<script>
import ListHeader from "@/components/ListHeader.vue";

import { mapGetters } from "vuex";

export default {
  name: "TermsAndConditions",
  components: {
    ListHeader,
  },
  computed: {
    ...mapGetters(["init"]),
  },
};
</script>
